import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { useGetClientInsuranceLink } from 'api/clients/use-get-client-insurance-link';
import { FilePreview } from 'components/common/file-preview';
import styles from './client-insurance-preview.module.scss';
import type { IClientInsurancePreviewProps } from './types';

export const ClientInsurancePreview = (props: IClientInsurancePreviewProps) => {
  const { clientId, insuranceId, fileName, mimeType } = props;
  const { t } = useTranslation('client');
  const { mutateAsync: getInsuranceLink } = useGetClientInsuranceLink();

  return (
    <FilePreview
      fileName={fileName}
      mimeType={mimeType}
      getFileLink={() => getInsuranceLink({ clientId, insuranceId })}
      renderTrigger={({ isLoading, onClick }) => (
        <Button
          className={styles.previewButton}
          icon={<EyeOutlined />}
          aria-label={t('insurance_preview')}
          loading={isLoading}
          onClick={onClick}
        />
      )}
    />
  );
};
